var React = require('react');

function CloseMedium (props) {
    return React.createElement("svg",props,React.createElement("path",{"transform":"translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000)","d":"M13.5,11 L18,11 C18.5522847,11 19,11.4477153 19,12 L19,12.5 C19,13.0522847 18.5522847,13.5 18,13.5 L13.5,13.5 L13.5,18 C13.5,18.5522847 13.0522847,19 12.5,19 L12,19 C11.4477153,19 11,18.5522847 11,18 L11,13.5 L6,13.5 C5.44771525,13.5 5,13.0522847 5,12.5 L5,12 C5,11.4477153 5.44771525,11 6,11 L11,11 L11,6 C11,5.44771525 11.4477153,5 12,5 L12.5,5 C13.0522847,5 13.5,5.44771525 13.5,6 L13.5,11 Z","fill":"currentColor","id":"close-medium"}));
}

CloseMedium.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = CloseMedium;

CloseMedium.default = CloseMedium;
